export default __webpack_public_path__ + "static/media/my-yoast-academy-logo.6377a197.svg";